export const mockJobs = [
  {
    id: "1",
    title: "Warehouse Operations Manager",
    company: "TechVision Factory",
    companyDesc: "TechVision Factory is a leading USA-based electronics manufacturer with 15+ years of experience producing consumer tech products for global brands.",
    logo: "https://public.readdy.ai/ai/img_res/f2627b900190bb8685d5e763b72b2d08.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=modern%20USA%20warehouse%20interior%20bright%20clean%20organized%20shelves%20workers%20team%20professional%20facility&width=800&height=300&seq=jobcover1&orientation=landscape",
    location: "Los Angeles, CA",
    type: "Full-time",
    salary: "$65,000 - $85,000/yr",
    category: "Manufacturing",
    description: "Oversee daily warehouse operations, manage a team of 20+ staff, coordinate with logistics partners and ensure timely order fulfillment. You will be responsible for inventory accuracy, safety compliance, and continuous process improvement.",
    requirements: ["3+ years warehouse management experience", "Proficiency in WMS software", "Strong leadership and communication skills", "Forklift certification preferred", "Ability to lift 50 lbs"],
    benefits: ["Health & Dental Insurance", "401(k) with 5% match", "Paid Time Off (15 days/yr)", "Overtime Pay", "Annual Performance Bonus"],
    posted: "2 days ago",
    verified: true,
    urgent: true,
    applicants: 24,
    views: 312,
  },
  {
    id: "2",
    title: "E-Commerce Sales Representative",
    company: "GreenThread Mills",
    companyDesc: "GreenThread Mills is an organic textile manufacturer based in New York, supplying eco-friendly fabrics and apparel to retailers across North America.",
    logo: "https://readdy.ai/api/search-image?query=green%20textile%20company%20logo%20icon%20leaf%20square%20organic%20minimal&width=64&height=64&seq=job2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=young%20professional%20sales%20team%20office%20USA%20modern%20bright%20smiling%20diverse%20people%20working%20together&width=800&height=300&seq=jobcover2&orientation=landscape",
    location: "New York, NY",
    type: "Full-time",
    salary: "$45,000 - $60,000/yr + Commission",
    category: "Sales",
    description: "Drive online sales through the StarBookPrime platform, manage customer relationships, and develop new business opportunities with local buyers. You will handle inbound leads, conduct product demos, and close deals with wholesale buyers.",
    requirements: ["1+ year sales experience", "Excellent written and verbal communication", "CRM software experience (HubSpot preferred)", "Self-motivated and target-driven", "Knowledge of e-commerce platforms"],
    benefits: ["Uncapped Commission Structure", "Health Insurance", "Remote Work Fridays", "Sales Training Program", "Team Incentive Trips"],
    posted: "1 day ago",
    verified: true,
    urgent: false,
    applicants: 41,
    views: 528,
  },
  {
    id: "3",
    title: "Social Media Content Creator",
    company: "PureGlow Labs",
    companyDesc: "PureGlow Labs is a fast-growing skincare brand based in Miami, known for clean beauty formulations and a strong social media presence with 2M+ followers.",
    logo: "https://readdy.ai/api/search-image?query=beauty%20brand%20logo%20pink%20square%20icon%20professional%20clean%20minimal&width=64&height=64&seq=job3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=young%20woman%20content%20creator%20filming%20beauty%20products%20bright%20studio%20colorful%20background%20social%20media%20influencer&width=800&height=300&seq=jobcover3&orientation=landscape",
    location: "Miami, FL (Remote OK)",
    type: "Part-time",
    salary: "$25 - $40/hr",
    category: "Marketing",
    description: "Create engaging TikTok, YouTube, and Instagram content showcasing our skincare products. Work with influencer partners to amplify brand reach and drive product awareness. You will script, film, and edit short-form videos and manage content calendars.",
    requirements: ["Portfolio of social media content required", "Proficiency in video editing (CapCut, Premiere)", "Understanding of TikTok & Instagram algorithms", "Creative storytelling ability", "Skincare/beauty interest a plus"],
    benefits: ["Free Product Allowance ($200/mo)", "Flexible Remote Schedule", "Creative Freedom", "Performance Bonuses", "Brand Collaboration Opportunities"],
    posted: "3 days ago",
    verified: true,
    urgent: false,
    applicants: 67,
    views: 890,
  },
  {
    id: "4",
    title: "Logistics Coordinator",
    company: "HydroForge Co.",
    companyDesc: "HydroForge Co. is a Houston-based industrial equipment manufacturer specializing in water treatment systems and hydraulic components for commercial clients.",
    logo: "https://readdy.ai/api/search-image?query=water%20industrial%20company%20logo%20teal%20square%20icon%20minimal%20professional&width=64&height=64&seq=job4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=logistics%20coordinator%20USA%20warehouse%20trucks%20shipping%20dock%20bright%20modern%20facility%20team%20working&width=800&height=300&seq=jobcover4&orientation=landscape",
    location: "Houston, TX",
    type: "Full-time",
    salary: "$50,000 - $65,000/yr",
    category: "Logistics",
    description: "Coordinate shipping and delivery operations, manage carrier relationships, track shipments, and ensure customer satisfaction with delivery experience. You will work closely with our warehouse team and third-party logistics providers to optimize delivery routes.",
    requirements: ["2+ years logistics or supply chain experience", "Familiarity with freight and carrier systems", "Strong organizational skills", "Proficiency in Excel and TMS software", "DOT regulations knowledge preferred"],
    benefits: ["Medical & Dental Insurance", "Paid Time Off", "$500 Signing Bonus", "401(k)", "Career Advancement Path"],
    posted: "5 days ago",
    verified: true,
    urgent: true,
    applicants: 18,
    views: 245,
  },
  {
    id: "5",
    title: "Product Photography Specialist",
    company: "SoundWave Factory",
    companyDesc: "SoundWave Factory is a Chicago-based consumer electronics brand producing premium audio equipment including headphones, speakers, and smart home devices.",
    logo: "https://readdy.ai/api/search-image?query=sound%20music%20company%20logo%20orange%20square%20icon%20minimal%20professional&width=64&height=64&seq=job5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=product%20photographer%20studio%20setup%20professional%20camera%20lighting%20equipment%20modern%20creative%20space%20electronics&width=800&height=300&seq=jobcover5&orientation=landscape",
    location: "Chicago, IL",
    type: "Contract",
    salary: "$35 - $55/hr",
    category: "Creative",
    description: "Shoot professional product photos and videos for our electronics catalog. Experience with e-commerce photography and video editing required. You will work in our in-house studio to produce high-quality imagery for our website, Amazon listings, and marketing campaigns.",
    requirements: ["Professional photography portfolio required", "Experience with studio lighting setups", "Proficiency in Adobe Lightroom & Photoshop", "Video editing skills (Premiere Pro)", "Own camera equipment preferred"],
    benefits: ["Studio Access Provided", "Flexible Contract Hours", "Portfolio Building Opportunity", "Potential Full-time Conversion", "Equipment Stipend"],
    posted: "1 week ago",
    verified: true,
    urgent: false,
    applicants: 33,
    views: 410,
  },
  {
    id: "6",
    title: "Customer Service Specialist",
    company: "FitForge Manufacturing",
    companyDesc: "FitForge Manufacturing is a Phoenix-based fitness equipment company producing commercial-grade gym equipment for hotels, gyms, and home fitness enthusiasts.",
    logo: "https://readdy.ai/api/search-image?query=fitness%20sports%20company%20logo%20orange%20red%20square%20icon%20minimal%20professional&width=64&height=64&seq=job6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=young%20woman%20working%20from%20home%20laptop%20headset%20smiling%20bright%20home%20office%20setup%20customer%20service%20remote&width=800&height=300&seq=jobcover6&orientation=landscape",
    location: "Phoenix, AZ (Remote)",
    type: "Full-time",
    salary: "$38,000 - $48,000/yr",
    category: "Customer Service",
    description: "Handle customer inquiries, resolve order issues, process returns, and maintain high satisfaction scores. You will be the first point of contact for our customers via phone, email, and live chat. Bilingual (English/Spanish) preferred.",
    requirements: ["1+ year customer service experience", "Excellent communication skills", "Patience and problem-solving ability", "Bilingual English/Spanish a strong plus", "Familiarity with Zendesk or similar CRM"],
    benefits: ["100% Remote Work", "Equipment Provided", "Bilingual Pay Bonus (+$3K/yr)", "Health Insurance", "Paid Training Program"],
    posted: "4 days ago",
    verified: true,
    urgent: false,
    applicants: 52,
    views: 634,
  },
  {
    id: "7",
    title: "Quality Control Inspector",
    company: "TechVision Factory",
    companyDesc: "TechVision Factory is a leading USA-based electronics manufacturer with 15+ years of experience producing consumer tech products for global brands.",
    logo: "https://readdy.ai/api/search-image?query=tech%20company%20logo%20icon%20orange%20square%20professional%20modern%20minimal&width=64&height=64&seq=job1&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=quality%20control%20inspector%20USA%20factory%20production%20line%20checking%20products%20professional%20clean%20facility&width=800&height=300&seq=jobcover7&orientation=landscape",
    location: "Los Angeles, CA",
    type: "Full-time",
    salary: "$42,000 - $55,000/yr",
    category: "Manufacturing",
    description: "Inspect finished goods and in-process products to ensure they meet quality standards. Document defects, coordinate with production teams, and implement corrective actions to maintain our ISO 9001 certification.",
    requirements: ["2+ years QC experience in manufacturing", "Knowledge of ISO 9001 standards", "Attention to detail", "Ability to use measurement tools and gauges", "Basic computer skills for reporting"],
    benefits: ["Health Insurance", "401(k)", "Paid Training", "Uniform Provided", "Shift Differential Pay"],
    posted: "3 days ago",
    verified: true,
    urgent: false,
    applicants: 15,
    views: 198,
  },
  {
    id: "8",
    title: "Graphic Designer — Packaging",
    company: "GreenThread Mills",
    companyDesc: "GreenThread Mills is an organic textile manufacturer based in New York, supplying eco-friendly fabrics and apparel to retailers across North America.",
    logo: "https://readdy.ai/api/search-image?query=green%20textile%20company%20logo%20icon%20leaf%20square%20organic%20minimal&width=64&height=64&seq=job2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=graphic%20designer%20working%20on%20packaging%20design%20computer%20screen%20creative%20studio%20modern%20bright%20workspace&width=800&height=300&seq=jobcover8&orientation=landscape",
    location: "New York, NY (Hybrid)",
    type: "Full-time",
    salary: "$55,000 - $70,000/yr",
    category: "Creative",
    description: "Design product packaging, labels, and brand collateral for our organic apparel line. You will collaborate with the marketing team to create visually compelling designs that communicate our eco-friendly brand values.",
    requirements: ["3+ years graphic design experience", "Expert in Adobe Illustrator & InDesign", "Packaging design portfolio required", "Understanding of print production processes", "Brand identity experience preferred"],
    benefits: ["Creative Work Environment", "Health & Vision Insurance", "Hybrid Schedule (3 days office)", "Annual Design Conference Budget", "Employee Discount on Products"],
    posted: "6 days ago",
    verified: true,
    urgent: false,
    applicants: 29,
    views: 367,
  },
];
